document.addEventListener("DOMContentLoaded", () => {
  console.log("Salve roemer framework!");
});
